import * as yup from 'yup'
import { MakeRequiredAndNullable } from './utils.js'

export const diversifiedBotanicalsInventoryLabelFileDataSchema = yup.object().shape({
  logo: yup.string().nullable().optional(),
  itemId: yup.string().nullable().optional(),
  itemBarcode: yup.string().nullable().optional(),
  itemName: yup.string().nullable().optional(),
  lotNumber: yup.string().nullable().optional(),
  lotBarcode: yup.string().nullable().optional(),
  expirationDate: yup.string().nullable().optional(),
  qtyUnit: yup.string().nullable().optional(),
  qty: yup.string().nullable().optional(),
})

export type DiversifiedBotanicalsInventoryLabelFileData = yup.InferType<
  typeof diversifiedBotanicalsInventoryLabelFileDataSchema
>

type RequiredFileData = MakeRequiredAndNullable<DiversifiedBotanicalsInventoryLabelFileData>

export const diversifiedBotanicalsInventoryLabelFileMappings: RequiredFileData = {
  logo: '97d80392-dfe0-4e7d-abec-36cf49e2ba6a',
  itemId: 'b0c94529-4f16-4dbf-b245-b5a32835d919',
  itemBarcode: 'd929596b-7b23-4027-b3cd-e84d52b2d040',
  itemName: '9b75f6bb-aee5-4b39-92a2-b051325ccd3f',
  lotNumber: 'cafae81c-988f-48ac-b944-6ead55a07562',
  lotBarcode: 'fe5835a3-fe18-4e8e-96ca-80f27b60b649',
  expirationDate: 'c9b1a21a-9df6-4faf-b91f-445d071a7605',
  qtyUnit: 'b0e24b3c-7688-4b7e-833d-389f2f177a1d',
  qty: '43251fc4-e732-4537-b5d1-b396f3027224',
}

export const mockDiversifiedBotanicalsInventoryLabelFileData: RequiredFileData = {
  logo: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNk+M9QDwADhgGAWjR9awAAAABJRU5ErkJggg==',
  itemId: 'ITEM-001',
  itemBarcode:
    'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEEAAAAyCAIAAACMIyF9AAAAbklEQVR4nO3PMQrAMAwEwSP///O5SBOwsNsN7FSyEYhNkrZt3yHJPuzP7/9h+bB23Rxvjeee/J8NDDYw2MBgA4MNDDYw2MBgA4MNDDYw2MBgA4MNDDYw2MBgA4MNDDYw2MBgA4MNDDYw2MBgA8MCXyNaCS3W+zgAAAAASUVORK5CYII=',
  itemName: 'MIT45 Kratom Extract',
  lotNumber: 'LOT35120616',
  lotBarcode:
    'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEEAAAAyCAIAAACMIyF9AAAAbklEQVR4nO3PMQrAMAwEwSP///O5SBOwsNsN7FSyEYhNkrZt3yHJPuzP7/9h+bB23Rxvjeee/J8NDDYw2MBgA4MNDDYw2MBgA4MNDDYw2MBgA4MNDDYw2MBgA4MNDDYw2MBgA4MNDDYw2MBgA8MCXyNaCS3W+zgAAAAASUVORK5CYII=',
  expirationDate: '6/22/2026',
  qtyUnit: '1/KG',
  qty: '1000 - KG',
}
